<template>
  <div class="content-box">
    <div
      class="support-index"
      :class="{ 'show-ticket-content': tareaSeleccionada != null }"
    >
      <div class="support-tickets" v-if="tareaSeleccionada == null">
        <div class="support-tickets-header">
          <div class="tickets-control">
            <h5>Tareas</h5>
          </div>
        </div>
        <CrearTareaColaModalComponent @refresh="regresar" />
        <TareaTicketComponent
          v-for="current in mis_tareas"
          v-bind:key="current.id"
          :current="current"
          @onTicketClick="seleccionarTarea"
        />
      </div>
      <TareaContentComponent
        v-if="tareaSeleccionada != null"
        :current="tareaSeleccionada"
        :lista="detalle"
        @regresar="regresar"
        @seleccionarTarea="seleccionarTarea"
      />
    </div>
    <ModalAsignarCarritoComponent
      if="id_tarea"
      :id_tarea="id_tarea"
      @asignado_carrito="asignado_carrito"
    />
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DynamicService from "@/services/commons/DynamicService";
import TareaTicketComponent from "@/components/wms/tareas/TareaTicketComponent";
import TareaContentComponent from "@/components/wms/tareas/TareaContentComponent";
import ModalAsignarCarritoComponent from "@/components/wms/tareas/ModalAsignarCarritoComponent";
import CrearTareaColaModalComponent from "@/components/wms/tareas/CrearTareaColaModalComponent";

export default {
  components: {
    UsuarioEnTablaComponent,
    TareaTicketComponent,
    TareaContentComponent,
    ModalAsignarCarritoComponent,
    CrearTareaColaModalComponent,
  },
  data() {
    return {
      mis_tareas: [],
      tareaSeleccionada: null,
      id_tarea: null,
      detalle: [],
    };
  },
  mounted() {
    this.refreshTareas();
    if (this.$route.params.id) {
      this.seleccionarTarea(this.$route.params.id);
    }
  },
  methods: {
    refreshTareas() {
      let self = this;
      DynamicService.fetch("wms", "tareas", {
        mis_tareas: true,
        estado: "A",
      }).then((resp) => {
        self.mis_tareas = resp.data.results;
      });
    },
    seleccionarTarea(id) {
      let self = this;
      self.refreshTareas();
      DynamicService.getById("wms", "tareas", id)
        .then((res) => {
          if (res.data.posicion_picking != null) {
            self.tareaSeleccionada = res.data;
            self.detalle = res.data.detalle;
            self.$router.push({
              name: "wms-tareas-editar",
              params: { id: self.tareaSeleccionada.id },
            });
          } else {
            self.regresar();
            self.id_tarea = res.data.id;
            $("#asignarCarrito").modal("show");
            $("#barra_carrito").focus();
          }
        })
        .catch((err) => {});
    },
    regresar() {
      let self = this;
      self.refreshTareas();
      self.tareaSeleccionada = null;
      self.id_tarea = null;
      self.$router.push({
        name: "wms-tareas",
        params: {},
      });
    },
    asignado_carrito(id) {
      this.seleccionarTarea(id);
    },
  },
};
</script>
